<template>
  <div :style="{ padding: getPadding() }">
    <!--提示信息-->
    <div v-show="noticeVisible" class="notice content">
      <div>
        <i class="iconfont">&#xe6e5;</i>
        <span
          >以下操作记录只包含系统自动、技术专家、以及亲在软件中所做的操作，无法获取亲在阿里妈妈官方后台或其他软件中的操作记录哦</span
        >
      </div>
      <i class="iconfont" @click="noticeVisible = false">&#xe6c7;</i>
    </div>
    <!--内容区-->
    <div class="content" :style="{ height: getContentHeight() }">
      <!--搜索、平台、日期选择-->
      <div class="history-top flex-between align-center">
        <div>
          <el-tabs v-model="platform">
            <el-tab-pane
              v-for="item in platGroup"
              :label="item.label"
              :name="item.name"
              :key="item.name"
            />
          </el-tabs>
        </div>
        <div class="flex-end align-center">
          <div v-show="!isAdHistory" style="margin-top: 4px">
            <SearchBtn
              :searchFn="searchFn"
              currentPlaceholder="请输入宝贝标题"
              :maxWidth="160"
            />
          </div>
          <DatePicker
            ref="datePicker"
            @emitDateRes="listenDateRes"
            :dateLength="2"
            :pickToday="true"
            :isCompare="false"
            class="pl8"
          />
        </div>
      </div>
      <!--操作记录表格-->
      <el-table
        :data="historyList"
        ref="historyTable"
        :max-height="getMaxHeight()"
        :row-key="
          (row) => {
            return `${row.rid}`;
          }
        "
        @filter-change="filterChange"
      >
        <el-table-column :width="157">
          <template v-slot:header>
            <div class="table-tl pl20">时间</div>
          </template>
          <template v-slot:default="scope">
            <div class="table-tl pl20">{{ scope.row.opt_time }}</div>
          </template>
        </el-table-column>
        <!--首页的计划可选，宝贝的计划是固定不可选-->
        <el-table-column v-if="isAdHistory" :width="298" columnKey="campaignId">
          <template v-slot:header>
            <div class="table-tl pl20">{{ headerObject.campaignName }}</div>
          </template>
          <template v-slot:default="scope">
            <div class="table-tl pl20">{{ scope.row.campaign_name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :width="298"
          :filter-multiple="false"
          :filters="campaignFilters"
          filter-placement="bottom"
          label-class-name="filter-column"
          columnKey="campaignId"
          :label="headerObject.campaignName"
        >
          <!-- <template v-slot:header>
            <div class="campaign-name pl20">
              {{ headerObject.campaignName }}
            </div>
          </template> -->
          <template v-slot:default="scope">
            <div class="table-tl pl20">{{ scope.row.campaign_name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          :width="74"
          :filter-multiple="false"
          :filters="opTypeFilters"
          filter-placement="bottom"
          columnKey="opType"
          :label="headerObject.opName"
          prop="op_type"
        >
        </el-table-column>
        <el-table-column
          :width="120"
          :filter-multiple="false"
          :filters="funcTypeFilters"
          filter-placement="bottom"
          columnKey="funcType"
          :label="headerObject.funcName"
          prop="func_type"
        >
        </el-table-column>
        <el-table-column
          :width="74"
          :filter-multiple="false"
          :filters="opterFilters"
          filter-placement="bottom"
          columnKey="opter"
          :label="headerObject.opterName"
          prop="opter"
        >
        </el-table-column>
        <el-table-column
          :width="100"
          label="操作"
          prop="data_type"
        ></el-table-column>
        <el-table-column>
          <template v-slot:header>
            <div class="table-tl">详细</div>
          </template>
          <template v-slot:default="scope">
            <div class="table-tl">
              {{ scope.row.detail_list[0] }}
              <template v-if="scope.row.detail_list.length > 1">
                <el-popover placement="bottom" trigger="click">
                  <div class="history-popover">
                    <div v-html="getContentHtml(scope.row.detail_list)"></div>
                  </div>
                  <span slot="reference" class="pointer">
                    <span class="theme-color">&nbsp;查看明细</span>
                    <i class="iconfont f12 theme-color ml2 dib">&#xe6b6;</i>
                  </span>
                </el-popover>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--分页信息-->
      <Pagination
        :page="historyObject.page"
        @emitPageInfo="listenHistoryPage"
      ></Pagination>
    </div>
  </div>
</template>

<!--TODO yeteng 20200930 日期无法选择今天，过去三天也不包括今天-->

<script>
import DatePicker from "../../components/DatePicker";
import Pagination from "../../components/Pagination";
import SearchBtn from "../../components/SearchBtn";

export default {
  name: "ShowHistory",
  components: { DatePicker, Pagination, SearchBtn },
  props: {
    // 宝贝页面的操作记录需要传入 campaignID和adgroupId
    isAdHistory: {
      type: Boolean,
      required: true,
    },
    campaignId: {
      type: Number,
      required: false,
    },
    adgroupId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      noticeVisible: true,
      platGroup: [],
      platform: "1",
      searchValue: "",
      historyList: [],
      theadArray: [],
      campaignDict: {},
      opDict: {},
      funcDict: {},
      opterDict: {},
      campaignFilters: [],
      opTypeFilters: [],
      funcTypeFilters: [],
      opterFilters: [],
      platformFilters: {},
      filterObject: {
        startDate: new Date().calc(2),
        endDate: new Date().format(),
        campaignId: -1,
        adgroupId: -1,
        opType: -1,
        funcType: -1,
        opter: -1,
        pageSize: 50,
        currentPage: 1,
      },
      historyObject: {
        visible: false,
        data: [],
        page: {},
      },
      headerObject: {
        campaignName: "推广计划",
        opName: "数据类型",
        funcName: "功能",
        opterName: "操作人",
      },
    };
  },
  beforeMount() {
    if (this.isAdHistory) {
      this.filterObject.campaignId = this.campaignId;
      this.filterObject.adgroupId = this.adgroupId;
    }
    this.initHistory();
  },
  mounted() {
    this.$nextTick(() => {
      // 操作记录默认显示最近三天的数据，与报表的日历控件不同
      let startDesc = this.filterObject.startDate.slice(5, 10);
      let endDesc = this.filterObject.endDate.slice(5, 10);
      this.$refs.datePicker.dateValue = `${startDesc} 至 ${endDesc}`;
      this.$refs.datePicker.pickResult = [
        this.filterObject.startDate,
        this.filterObject.endDate,
      ];
      this.$refs.datePicker.getRangeDate();
      this.$refs.datePicker.tempDateValue = `${startDesc} 至 ${endDesc}`;
      this.$refs.datePicker.activeQuickPicker = -1;
    });
  },
  methods: {
    //搜索操作记录
    searchFn(value) {
      this.searchValue = value.trim();
    },
    initHistory() {
      this.$axios(
        "/api/kcjl/system/",
        {
          func: "op_history",
        },
        (res) => {
          if (!this.isAdHistory) {
            this.initCampaignFilters(res.data[0]["main_list"]);
          }
          this.opDict = res.data[0]["op_dict"];
          // 宝贝的操作记录数据类型不需要计划
          if (this.isAdHistory) {
            delete this.opDict[1];
          }
          this.funcDict = res.data[0]["func_dict"];
          this.opterDict = res.data[0]["opter_dict"];
          const _platGroup = res.data[0]["platform_dict"];
          Object.getOwnPropertyNames(_platGroup).forEach((key) => {
            this.platGroup.push({ label: _platGroup[key], name: key });
          });
          this.initDictFilters(this.opTypeFilters, this.opDict);
          this.initDictFilters(this.funcTypeFilters, this.funcDict);
          this.initDictFilters(this.opterFilters, this.opterDict);
          this.getHistoryList();
        }
      );
    },
    initCampaignFilters(temps) {
      for (let i in temps) {
        let text = "";
        if (temps[i].mnt_type) {
          text = temps[i].mnt_type + "：" + temps[i].name;
        } else {
          text = temps[i].name;
        }
        this.campaignFilters.push({ text: text, value: temps[i].id });
        this.campaignDict[temps[i].id] = text;
      }
    },
    initDictFilters(array, temps) {
      for (let i in temps) {
        array.push({ text: temps[i], value: i });
      }
    },
    filterChange(filters) {
      if (filters.campaignId) {
        this.filterObject.campaignId = filters.campaignId[0]
          ? filters.campaignId[0]
          : -1;
        this.headerNameChange("campaign");
      } else if (filters.opType) {
        this.filterObject.opType = filters.opType[0] ? filters.opType[0] : -1;
        this.headerNameChange("op");
      } else if (filters.funcType) {
        this.filterObject.funcType = filters.funcType[0]
          ? filters.funcType[0]
          : -1;
        this.headerNameChange("func");
      } else if (filters.opter) {
        this.filterObject.opter = filters.opter[0] ? filters.opter[0] : -1;
        this.headerNameChange("opter");
      }
      this.getHistoryList();
    },
    // 动态调整表头
    headerNameChange(type) {
      switch (type) {
        case "campaign":
          this.headerObject.campaignName = "推广计划";
          if (this.filterObject.campaignId !== -1) {
            this.headerObject.campaignName =
              this.campaignDict[this.filterObject.campaignId];
          }
          break;
        case "op":
          this.headerObject.opName = "数据类型";
          if (this.filterObject.opType !== -1) {
            this.headerObject.opName = this.opDict[this.filterObject.opType];
          }
          break;
        case "func":
          this.headerObject.funcName = "功能";
          if (this.filterObject.funcType !== -1) {
            this.headerObject.funcName =
              this.funcDict[this.filterObject.funcType];
          }
          break;
        case "opter":
          this.headerObject.opterName = "操作人";
          if (this.filterObject.opter !== -1) {
            this.headerObject.opterName =
              this.opterDict[this.filterObject.opter];
          }
          break;
      }
    },
    getHistoryList(pageFlag) {
      // 考虑场景： 用户查看全部数据并选择了最后一页P，然后页面上操作了筛选功能，这时新数据的页数是小于P的，导致页面显示无记录，但有分页；
      // 解决： 只有点击页码时才传入当前页数，其他情况都默认查询第一页，通过pageFlag实现. TODO yeteng 20201029 目前分页组件显示不支持
      pageFlag = pageFlag || false;
      if (pageFlag === false) {
        this.filterObject.currentPage = 1;
      }
      this.$loading();
      this.filterToNumber();
      this.$axios(
        "/api/kcjl/system/",
        {
          func: "get_history_list",
          platform: Number(this.platform), // 组件需字符串，需手工转下
          search_word: this.searchValue,
          start_date: this.filterObject.startDate,
          end_date: this.filterObject.endDate,
          campaign_id: this.filterObject.campaignId,
          adgroup_id: this.filterObject.adgroupId,
          op_type: this.filterObject.opType,
          func_type: this.filterObject.funcType,
          opter: this.filterObject.opter,
          page_size: this.filterObject.pageSize,
          current_page: this.filterObject.currentPage,
        },
        (res) => {
          this.$loading().close();
          this.historyList = res.data[0]["history_list"];
          this.historyObject.page = res.page;
          this.historyObject.data = res.data;
        }
      );
    },
    filterToNumber() {
      for (let i in this.filterObject) {
        if (i !== "startDate" && i !== "endDate") {
          this.filterObject[i] = Number(this.filterObject[i]);
        }
      }
    },
    getPadding() {
      if (this.isAdHistory) {
        return "0px";
      } else {
        return "0 20px";
      }
    },
    getContentHeight() {
      let cHeight = 0;
      let noticeHeight = this.noticeVisible ? 54 : 0;
      if (this.isAdHistory) {
        cHeight =
          document.documentElement.clientHeight - 14 - 122 - noticeHeight - 20;
      } else {
        cHeight =
          document.documentElement.clientHeight - 72 - noticeHeight - 20;
      }
      return `${cHeight}px`;
    },
    getMaxHeight() {
      let cHeight = 0;
      let noticeHeight = this.noticeVisible ? 54 : 0;
      if (this.isAdHistory) {
        cHeight =
          document.documentElement.clientHeight -
          14 -
          122 -
          82 -
          noticeHeight -
          40;
      } else {
        cHeight =
          document.documentElement.clientHeight - 72 - 82 - noticeHeight - 40;
      }
      return `${cHeight}px`;
    },
    getContentHtml(details) {
      let html = "";
      for (let i in details) {
        if (i > 0) {
          html += `<div class="mb10">${details[i]}</div>`;
        }
      }
      return html;
    },
    listenDateRes(res) {
      this.filterObject.startDate = res[0];
      this.filterObject.endDate = res[1];
      this.getHistoryList();
    },
    listenHistoryPage(pageInfo) {
      this.filterObject.pageSize = pageInfo[0];
      this.filterObject.currentPage = pageInfo[1];
      this.getHistoryList(true);
    },
  },
  watch: {
    platform() {
      this.getHistoryList();
    },
    searchValue() {
      this.getHistoryList();
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-name {
  max-width: 255px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-top {
  padding-top: 13px;
  padding-bottom: 12px;
}

.history-popover {
  max-height: 500px;
  overflow-y: scroll;
  padding: 14px 10px 4px 6px;
}
/deep/ .filter-column {
  padding-left: 20px !important;
}
/deep/ div .cell {
  display: unset !important;
}
/deep/ .el-tabs__item {
  line-height: unset;
}
</style>